export default  function scrollHidden() {
    const body = $('body');
    $('.filter-opener').on("click", function() {
        body.addClass('scroll-hidden');
        if(body.hasClass('search-active')) {
            body.removeClass('search-active');
        }
    })
    $(".filter-close, .btn-filter-apply").on('click', function() {
        body.removeClass('scroll-hidden');
    })
}